export default __webpack_public_path__ + "static/media/PuffyShoeNormal.2cf47e3a.jpg";